import React from 'react';

const iconColor = '#3D4F3D';

export function AnxietyIcon({ className = '' }) {
  return (
    <svg viewBox="0 0 64 64" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="32" cy="32" r="28" stroke={iconColor} strokeWidth="2" />
      <path d="M20 28 Q26 20 32 28 Q38 36 44 28" stroke={iconColor} strokeWidth="2" strokeLinecap="round" fill="none" />
      <circle cx="32" cy="42" r="2" fill={iconColor} />
      <path d="M32 8 L32 14 M32 50 L32 56 M8 32 L14 32 M50 32 L56 32" stroke={iconColor} strokeWidth="1.5" strokeLinecap="round" opacity="0.4" />
    </svg>
  );
}

export function StressIcon({ className = '' }) {
  return (
    <svg viewBox="0 0 64 64" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="32" cy="32" r="28" stroke={iconColor} strokeWidth="2" />
      <path d="M20 32 Q24 24 28 32 Q32 40 36 32 Q40 24 44 32" stroke={iconColor} strokeWidth="2" strokeLinecap="round" fill="none" />
      <path d="M26 18 L32 12 L38 18" stroke={iconColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" opacity="0.5" />
      <path d="M26 46 L32 52 L38 46" stroke={iconColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" opacity="0.5" />
    </svg>
  );
}

export function CrisisIcon({ className = '' }) {
  return (
    <svg viewBox="0 0 64 64" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16 48 Q16 32 32 32 Q48 32 48 16" stroke={iconColor} strokeWidth="2" strokeLinecap="round" fill="none" />
      <circle cx="16" cy="48" r="6" stroke={iconColor} strokeWidth="2" />
      <circle cx="48" cy="16" r="6" stroke={iconColor} strokeWidth="2" />
      <path d="M28 20 L32 16 L36 20" stroke={iconColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" opacity="0.6" />
      <path d="M32 16 L32 28" stroke={iconColor} strokeWidth="2" strokeLinecap="round" opacity="0.6" />
    </svg>
  );
}

export function TraumaIcon({ className = '' }) {
  return (
    <svg viewBox="0 0 64 64" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="32" cy="32" r="28" stroke={iconColor} strokeWidth="2" strokeDasharray="6 3" />
      <path d="M24 24 L32 40 L40 24" stroke={iconColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      <circle cx="32" cy="18" r="3" fill={iconColor} opacity="0.5" />
      <path d="M20 48 Q32 42 44 48" stroke={iconColor} strokeWidth="1.5" strokeLinecap="round" fill="none" opacity="0.3" />
    </svg>
  );
}

export function SelfEsteemIcon({ className = '' }) {
  return (
    <svg viewBox="0 0 64 64" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="32" cy="20" r="12" stroke={iconColor} strokeWidth="2" />
      <path d="M20 40 Q32 50 44 40" stroke={iconColor} strokeWidth="2" strokeLinecap="round" fill="none" />
      <path d="M32 32 L32 52" stroke={iconColor} strokeWidth="2" strokeLinecap="round" />
      <circle cx="24" cy="18" r="2" fill={iconColor} opacity="0.4" />
      <circle cx="40" cy="18" r="2" fill={iconColor} opacity="0.4" />
    </svg>
  );
}

export function IdentityIcon({ className = '' }) {
  return (
    <svg viewBox="0 0 64 64" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="32" cy="32" r="28" stroke={iconColor} strokeWidth="2" />
      <path d="M32 10 L32 54" stroke={iconColor} strokeWidth="1.5" strokeLinecap="round" opacity="0.3" />
      <circle cx="24" cy="28" r="8" stroke={iconColor} strokeWidth="2" fill="none" />
      <circle cx="40" cy="36" r="8" stroke={iconColor} strokeWidth="2" fill="none" />
    </svg>
  );
}

export function LGTBIIcon({ className = '' }) {
  return (
    <svg viewBox="0 0 64 64" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M32 8 L32 56" stroke={iconColor} strokeWidth="2" strokeLinecap="round" />
      <circle cx="32" cy="32" r="20" stroke={iconColor} strokeWidth="2" />
      <path d="M18 24 Q32 16 46 24" stroke={iconColor} strokeWidth="1.5" strokeLinecap="round" fill="none" opacity="0.5" />
      <path d="M18 32 Q32 24 46 32" stroke={iconColor} strokeWidth="1.5" strokeLinecap="round" fill="none" opacity="0.4" />
      <path d="M18 40 Q32 32 46 40" stroke={iconColor} strokeWidth="1.5" strokeLinecap="round" fill="none" opacity="0.3" />
      <circle cx="32" cy="32" r="4" fill={iconColor} opacity="0.3" />
    </svg>
  );
}

export default {
  AnxietyIcon,
  StressIcon,
  CrisisIcon,
  TraumaIcon,
  SelfEsteemIcon,
  IdentityIcon,
  LGTBIIcon,
};
